/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-200);
  --font-size: var(--nve-ref-font-size-100);
  --height: 100px;
  --width: 100%;
  --min-height: 100px;
  --background: var(--nve-sys-interaction-field-background);
  --color: var(--nve-sys-interaction-field-color);
  --border-radius: var(--nve-ref-border-radius-sm);
  --cursor: text;
  --border: 0;
  display: block;
  width: var(--width);
  contain: layout;
}

::slotted(textarea) {
  font-size: var(--font-size) !important;
  margin: 0 !important;
  align-content: stretch !important;
  background: var(--background) !important;
  border: 0 !important;
  color: var(--color) !important;
  cursor: var(--cursor) !important;
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);
}

slot[name='prefix'],
slot[name='suffix'] {
  display: none;
  gap: var(--nve-ref-space-xxs);
}

@scope {
  :scope:has([slot='prefix']) slot[name='prefix'] {
    display: flex;
  }

  :scope:has([slot='suffix']) slot[name='suffix'] {
    display: flex;
  }

  :scope:has(textarea[style*='width'], textarea[cols]) [input] {
    width: fit-content;
  }

  :scope:has(textarea:focus-visible) [input] {
    outline: 5px auto -webkit-focus-ring-color !important;
    outline: Highlight solid 2px !important;
  }
}

[input] {
  flex-direction: column;
  gap: var(--nve-ref-space-xs);
  background: var(--background);
  border: var(--border);
  border-radius: var(--border-radius);
  padding: var(--padding);
  cursor: initial;
  outline: none !important;
}

::slotted(textarea:not([rows], [style*='height'])) {
  height: var(--height) !important;
  min-height: var(--min-height) !important;
}

::slotted(textarea:not([cols], [style*='width'])) {
  width: var(--width) !important;
}

::slotted(textarea:not([cols], [rows])) {
  field-sizing: content;
}

:host([layout*='horizontal']) ::slotted(label) {
  padding-block-start: var(--nve-ref-size-100) !important;
  align-self: start !important;
}

:host([layout*='horizontal']) slot[name='label'] {
  align-self: start;
}

:host([status='error']),
:host(:state(invalid)),
:host(:state(error)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-danger-emphasis-color);
}

:host([status='success']),
:host(:state(success)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-success-emphasis-color);
}

:host(:state(disabled)) {
  --border: var(--nve-ref-border-width-md) solid transparent;
}

:host([container='flat']) {
  --background: transparent;
  --border: var(--nve-ref-border-width-md) solid var(--nve-ref-border-color-muted);
}
